<template>
    <div id="app">
        <div class="bg" v-bind:style="{ backgroundImage: 'url(' + selectedImage + ')' }"></div>
        <router-view class="root"></router-view>
    </div>

</template>

<script>
    import 'axios'
    import 'buefy/dist/buefy.css'
    import Vue from 'vue'
    import Buefy from 'buefy'
    import Vee from 'vee-validate'
    import 'buefy/dist/buefy.css'

    Vue.use(Buefy)
    Vue.use(Vee)

    export default {
        name: 'app',
        components: {},
        data() {
            return {
                images: [
                    './assets/1.jpg',
                    './assets/2.jpg',
                    './assets/3.jpg',
                    './assets/4.jpg',
                    './assets/5.jpg',
                    './assets/6.jpg',
                    './assets/7.jpg',
                    './assets/8.jpg',
                ],
                selectedImage: ''
            }
        },
        created() {
            const idx = Math.floor(Math.random() * this.images.length)
            this.selectedImage = this.images[idx]

        }
    }
</script>

<style>
    #app {
        color: silver;
        display: grid;
        justify-content: space-evenly;
        font-family: 'Roboto' sans-serif;

    }
    .bg {
        position: fixed;
        z-index: 0;
        top: 0; left: 0;
        height: 100vh;
        background-size: cover;
        background-attachment: fixed;
        background-position: center center;
        width: 100vw;
    }
    body {
        background: black;
        min-height: 100%;
        height: 100%;
    }
    .root {
        position: relative;
        z-index: 1;
    }
    html{
        min-height: 100%;
    }

    a {
     color: silver;   
    }

    a:hover{
        color: #ff4581;
    }


    a:active{
        color: #ff4581;
    }
    ::-webkit-scrollbar
    {
    width: 6px;  /* for vertical scrollbars */
    height: 6px; /* for horizontal scrollbars */
    }

    ::-webkit-scrollbar-track
    {
    background: rgba(0, 0, 0, 0.1);
    }

    ::-webkit-scrollbar-thumb
    {
    background: rgba(0, 0, 0, 0.5);
    }



</style>
